import React, { useMemo, useEffect, Suspense, useState, useRef } from 'react'
import classes from "./scheduleSitesList.module.css";
import ListCard from '../../components/GridList/ListCard';
import BasicTable from '../../components/Table/Table/Table';
import { Await, Link, useLoaderData, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loading-icons';
import UseDateFormat from '../../components/hooks/UseDateFormat';
import Pill_Widget from '../../components/UI/Widgets/Pill_Widget';
import { useDispatch, useSelector } from 'react-redux';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../../components/hooks/UseSetCookie';
import Modal from '../../components/Modal/Modal';
import DataManager from '../../hooks/DataManager';
import OutputPinCircle from '../../components/UI/DataLayouts/OutputPinCircle';
import InputPinCircle from '../../components/UI/DataLayouts/InputPinCircle';
import useParseArrayDeviceData from '../../components/hooks/useParseArrayDeviceData';
import Button1 from '../../components/UI/Button/Button1';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import waitAnim from '../../assets/animations/pleasewait.json'
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import CreateHolidayMode from '../../components/UI/Cards/Automations/HolidayMode/CreateHolidayMode'
import { SelectButton } from 'primereact/selectbutton';
import CreateMassHolidayMode from '../../components/UI/Cards/Automations/HolidayMode/CreateMassHolidayMode';
import { useIsFocused } from 'rsuite/esm/DateInput';
import { getGroups } from '../../Api Methods/Api';

const ScheduleSitesList = ({ devices, refresh, setRefresh }) => {

  const [SiteDevices, setSiteDevices] = useState(devices)
  const token = useSelector(state => state.auth.token);
  const client = useSelector(state => state.auth.client);
  const dataManager = new DataManager();
  const parsedData = useParseArrayDeviceData(devices);
  let newSiteUUID = "";
  const loggedInAs = useSelector(state => state.auth.companyName);
  const apiData = { token, client }
  const ModalDialog = useRef();
  const [modalTitle, setModalTitle] = useState("title")
  const [modalComponent, setModalComponent] = useState()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checkedSites, setCheckedSites] = useState([])
  const [selectAllSites, setSelectAllSites] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [selectedMassAction, setSelectedMassAction] = useState("")
  const [holidayModeType, setHolidayModeType] = useState("")
  const [showMassSettings, setShowMassSettings] = useState(false)

  const [complete, setComplete] = useState(false)
  const [count, setCount] = useState(0);

  const [groups, setGroups] = useState([])

  useEffect(() => {
    setSiteDevices(devices);
  }, [devices])

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setSelectedMassAction("")
  }

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  }

  const HandleComplete = () => {
    HandleCloseModal();
    setRefresh(refresh+1)
  }

  const successModal = (message, count) => {
    setModalTitle('Success')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Temporary schedule created for {checkedSites.length} sites</h3>
        <br />
          <Button icon="pi pi-times" onClick={() => HandleComplete()} label="Close" severity='secondary'/>
        
      </div>
    )
    HandleShowModal();
  }

  const errorModal = (message, isCopyConfig) => {
    setModalTitle('Error')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
        <br />
          <Button icon="pi pi-times"onClick={HandleCloseModal} label="Cancel" severity='secondary'/>
      </div>
    )
    HandleShowModal();
  }

  const loadingModal = (message) => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={waitAnim} loop={true} style={{ width: 150, height: 150, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
      </div>
    )
    HandleShowModal();
  }

  useEffect(() => {
    GetGroups();
  }, [])

  const outputs =
  {
    output1: 1,
    output2: 0,
    output3: 0,
    output4: 1
  };

  const inputs =
  {
    input1: 1,
    input2: 1,
    input3: 1,
    input4: 1,
    input5: 0,
    input6: 1,
    input7: 1,
    input8: 0,
  };

  useEffect(() => {
  }, [checkedSites])

  const GetGroups = async () => {
    try {
      const listOptions = await getGroups(apiData, dispatch);
      setGroups(listOptions || []);
    } catch (error) {
      console.error('Failed to fetch groups:', error);
      setGroups([]);
    }
  };

  const HandleSiteChecked = (rowData) => {
    setCheckedSites(prevCheckedSites => {
      const exists = prevCheckedSites.some(site => site.id === rowData.id);
      if (exists) {
        return prevCheckedSites.filter(site => site.id !== rowData.id);
      } else {
        return [...prevCheckedSites, rowData];
      }
    });
  }

  const HandleSelectAllSites = () => {
    if (selectAllSites){
        setSelectAllSites(false)
        setCheckedSites([])
    } else {
        setSelectAllSites(true)
        setCheckedSites(SiteDevices)
    }
  }

  useEffect(() => {
    if (checkedSites.length > 0){
      setShowMassSettings(true)
    } else {
      setShowMassSettings(false)
      setSelectedMassAction("")
    }
  }, [checkedSites])

  let tablecolumns = [
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox 
                  onChange={e => HandleSelectAllSites()} 
                  checked={selectAllSites}>
                </Checkbox>
            </div>
          
          <h3 style={{marginLeft:"20px"}}>Portal site name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: "10px" }}> 
                  <Checkbox 
                    onChange={e => HandleSiteChecked(row.row.original)} 
                    checked={checkedSites.some((item) => item.id === row.row.original.id)}>
                  </Checkbox>
                </div>
              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
    {
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>{'My app site name'}</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }} onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </div>
        )
      }
    },
    {
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {

        return (
          <Link
              to={`/Dashboard/SiteView/${row.row.original.uuid}`}
              className={classes.tableValueText}
          >
              {row.row.original.key}
          </Link>
        )
      }
    },
    {
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Serial number</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      id: 'holidayMode',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Temporary schedule</h3>
        </div>
      ),
      filterLabel: "Temporary schedule",
      accessorKey: 'start',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.HMName && row.row.original.HMName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#8E7AB5"}
                PillColor_IfFalse={"#8E7AB5"}
                text_IfTrue={`Name: ${row.row.original.HMName}`}
                className={`${classes.PillHeight} ${classes.pillSpacing}`}                
              />
            )}
            {row.row.original.start && row.row.original.start.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#B784B7"}
                PillColor_IfFalse={"#B784B7"}
                text_IfTrue={`Start: ${HandleDateConversion(row.row.original.start)}`}
                className={`${classes.PillHeight} ${classes.pillSpacing}`}              />
            )}

            {row.row.original.end && row.row.original.end.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#E493B3"}
                PillColor_IfFalse={"#E493B3"}
                text_IfTrue={`End: ${HandleDateConversion(row.row.original.end)}`}
                className={classes.PillHeight}
              />
            )}

          </div>
        )
      }
    },
    {
      id: 'firmware',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Firmware</h3>
        </div>
      ),
      filterLabel: "Firmware",
      accessorKey: 'firmware',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.firmware}
          </div>
        )
      }
    },
    {
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={"Offline"}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      id: 'states',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>States</h3>
        </div>
      ),
      filterLabel: "States",
      cell: (row) => {
        const data = parsedData[row.row.index]
        return (
          <div className={classes["bottom-wrapper"]}>
            <div>
              <ul className={classes.outputs}>
                <OutputPinCircle outputs={outputs} OutputPins={data.OutputPins} />
              </ul>
            </div>
            <div className={classes["bottom-wrapper_divider"]} />
            <div>
              <ul className={classes.inputs}>
                <InputPinCircle inputs={inputs} InputPins={data.InputPins} />
              </ul>
            </div>
          </div>
        )
      }
    },
    {
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    }
  ];

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups.find(g => g.name === groupName);

    if (groupClicked) {
        sessionStorage.setItem('groupClicked', groupClicked.name)   
        sessionStorage.setItem('groupPath', groupClicked.group_path)
        sessionStorage.setItem('groupClickedID', groupClicked.id)   
        navigate("/Dashboard/Groups/GroupSites")
    }
  }


  const HandleSelectAll = () => {
    if (selectAll == null || !selectAll) {
      setSelectAll(true)
      setShowMassSettings(true)
    } else if (selectAll) {
      setSelectAll(false)
      setShowMassSettings(false)
    }
  }

  const HandleDateConversion = (utcDate) => {
    const localDate = new Date(utcDate).toLocaleString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return localDate;
  }

  const ShowActionCompleteModal = (passCount, failCount, action) => {
    setCheckedSites([])
    setSelectedMassAction("")
    dataManager.setItem('selectedGroup', "")
    setModalTitle("Complete")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Successfully {action} {passCount} sites</h3>
        {(failCount > 0) && (<h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failCount} sites failed to {action}</h3>)}
      </div>
    )
  }

  const showLoadingModal = () => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={waitAnim} loop={true} style={{ width: 150, height: 150, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Performing action, please wait...</h3>
      </div>
    )
    HandleShowModal();
  }

  useEffect(() => {
    switch (selectedMassAction){
      case "Create temporary schedule" : {
        setModalTitle("Create temporary schedule")
        setModalComponent(
          <div style={{
            display: 'flex',
            maxWidth:"700px",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center', 
            textAlign: 'center'
          }}>
            <h4 style={{color:"#828282", fontWeight:"400"}}><b>Mass temporary schedule</b> will create one temporary schedule and apply to all of the selected sites.</h4>
            
            <h4 style={{color:"#828282", fontWeight:"400"}}><b>Individual temporary schedule</b> will allow you to select the status of each output on a per site basis</h4>
            <br></br>
            <h4 style={{color:"#828282", fontWeight:"400"}}>Please be aware, creating a mass temporary schedule with sites that contain smart locks or a pulse may have adverse affects on the status of those outputs if not set-up correctly. </h4> 
            <h4 style={{color:"#828282", fontWeight:"400"}}>It is recommended to create indivdual temporary schedule or use 'ignore' when selecting output status in these situations.</h4>
            <br></br>
            <SelectButton value={holidayModeType} onChange={(e) => setHolidayModeType(e.value)} options={["Mass temporary schedule", "Individual"]} />
            
          </div>
        )

        HandleShowModal();
        setSelectedMassAction("")
        break;
      }
      default : {
        //do nothing?
      }
    }

  }, [selectedMassAction])

  useEffect(() => {

    if (complete){
      successModal()
    }
  }, [complete])

  useEffect(() => {
    if (holidayModeType != ""){
      HandleCloseModal();
      switch (holidayModeType){
        case "Mass temporary schedule" : {
          setModalTitle("Mass create temporary schedule")
          setModalComponent(
            <CreateMassHolidayMode uuids={checkedSites.map(site => site.uuid)} setComplete={setComplete} setCount={setCount} type={0} checkedSites={checkedSites} />
          )
          HandleShowModal();
          setHolidayModeType("")
        break;
        } 
        case "Individual" : {
          setModalTitle("Create individual temporary schedule")
          setModalComponent(
            <CreateMassHolidayMode uuids={checkedSites.map(site => site.uuid)} setComplete={setComplete} setCount={setCount} type={1} checkedSites={checkedSites}/>
          )
          HandleShowModal();
          setHolidayModeType("")
        break
        }
      }
    }
  }, [holidayModeType])

  const massActionOptions = [
    "Create temporary schedule"
  ]

  return (
    <>
      <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal}>
        {modalComponent}
      </Modal>

      <div className={`${classes.table} ${classes.center} `}>
        <ListCard secondaryClassName={classes["Card-container"]}>
          <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "0px 10px 0px 10px" }}>
            <Suspense fallback={
              <div className={classes["loadingSpinner-container"]}>
                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
              </div>}>

               {showMassSettings && (
                  <div style={{marginTop:"3px", marginBottom:"5px"}}>
                    <p style={{color:"#6e6e6e", fontWeight:"500"}} >{checkedSites.length} sites selected</p>
                      <Dropdown value={selectedMassAction} onChange={(e) => setSelectedMassAction(e.value)} options={massActionOptions} 
                        placeholder="Select an action" className="w-full md:w-14rem" />
                      {checkedSites.length > 0 && <Button label='Clear selections' outlined severity='danger' icon="pi pi-times" style={{ fontSize: "12px", width: "160px", padding: 12, marginLeft:"15px" }} onClick={() => setCheckedSites([])} />}
                        
                  </div>
                )}

              <Await resolve={SiteDevices}>
                {(loadedtableData) =>
                  <div style={{ width: "auto", minWidth: "1000px"}} >
                    <br></br>
                    <BasicTable
                      data={loadedtableData}
                      columns={tablecolumns}
                      allColumns={tablecolumns}
                      filtering={""}
                      rowClick={false}
                      ShowPagination={false}
                      PageSize={50000}
                      paginationOptions={[25, 50, 100]}
                      showFilterButton={false}
                      isSortable={false}
                    />
                  </div>
                }
              </Await>
            </Suspense>
            <br></br>
          </div>
        </ListCard>
      </div>
    </>
  )
}

export default ScheduleSitesList;